import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/readme': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M528.3 46.5H388.5C340.4 46.5 298.6 79.8 288.1 126.8 277.5 79.8 235.8 46.5 187.7 46.5H48C21.5 46.5 0 68 0 94.5V340.3C0 366.8 21.5 388.3 48 388.3H137.7C239.9 388.3 270.4 412.7 285 463.3 285.7 466.1 290.2 466.1 291 463.3 305.7 412.7 336.2 388.3 438.3 388.3H528C554.5 388.3 576 366.8 576 340.3V94.6C576 68.2 554.7 46.7 528.3 46.5zM242 311.9C242 313.8 240.5 315.4 238.5 315.4H78.2C76.3 315.4 74.7 313.9 74.7 311.9V289C74.7 287.1 76.2 285.5 78.2 285.5H238.6C240.5 285.5 242.1 287 242.1 289V311.9zM242 251C242 252.9 240.5 254.5 238.5 254.5H78.2C76.3 254.5 74.7 253 74.7 251V228.1C74.7 226.2 76.2 224.6 78.2 224.6H238.6C240.5 224.6 242.1 226.1 242.1 228.1V251zM242 190.1C242 192 240.5 193.6 238.5 193.6H78.2C76.3 193.6 74.7 192.1 74.7 190.1V167.2C74.7 165.3 76.2 163.7 78.2 163.7H238.6C240.5 163.7 242.1 165.2 242.1 167.2V190.1zM501.3 311.8C501.3 313.7 499.8 315.3 497.8 315.3H337.5C335.6 315.3 334 313.8 334 311.8V288.9C334 287 335.5 285.4 337.5 285.4H497.9C499.8 285.4 501.4 286.9 501.4 288.9V311.8zM501.3 250.9C501.3 252.8 499.8 254.4 497.8 254.4H337.5C335.6 254.4 334 252.9 334 250.9V228C334 226.1 335.5 224.5 337.5 224.5H497.9C499.8 224.5 501.4 226 501.4 228V250.9zM501.3 190C501.3 191.9 499.8 193.5 497.8 193.5H337.5C335.6 193.5 334 192 334 190V167.2C334 165.3 335.5 163.7 337.5 163.7H497.9C499.8 163.7 501.4 165.2 501.4 167.2V190z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/readme.js
// module id = Fq2l
// module chunks = 144